import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=70815c9b&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=70815c9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70815c9b",
  null
  
)

export default component.exports